import type { Event } from 'effector'
import type { RouterResponse } from './router'

import { split } from 'effector'

// stages
//  - 'navigate' is used for initial route render,
//  - 'refresh' is used for re-initialize data for route
//  - 'reload' is used for hard reload of the page (e.g. when user clicks browser reload button)
export type Staged = {
  stage: 'navigate' | 'refresh' | 'reload'
}

export const stage = {
  // extend route object with `navigate` stage
  navigate: (route: RouterResponse): RouterResponse & Staged => ({
    ...route,
    stage: 'navigate',
  }),

  // extend route object with `refresh` stage
  refresh: (route: RouterResponse): RouterResponse & Staged => ({
    ...route,
    stage: 'refresh',
  }),

  // extend route object with `reload` stage
  reload: (route: RouterResponse): RouterResponse & Staged => ({
    ...route,
    stage: 'reload',
  }),
}

export const stages = <T extends Staged>(
  init: Event<T>
): {
  navigate: Event<T>
  refresh: Event<T>
  reload: Event<T>
} =>
  split(init, {
    navigate: ({ stage }) => stage === 'navigate',
    refresh: ({ stage }) => stage === 'refresh',
    reload: ({ stage }) => stage === 'reload',
  })
